<template>
  <v-card>
    <v-card>
      <v-card-title
        v-if="usuario && usuario.projetos && usuario.projetos.length > 0"
      >
        <v-select
          label="Projeto Firebase"
          :items="usuario.projetos"
          v-model="projeto"
        ></v-select>
      </v-card-title>
      <v-bottom-nav
          color="primary"
          :value="true"
          dark
          shift
        >
          <v-btn dark @click="step = 1">
            <span>Dados pessoais</span>
            <v-icon>account_circle</v-icon>
          </v-btn>

          <v-btn dark @click="step = 2">
            <span>Endereço</span>
            <v-icon>place</v-icon>
          </v-btn>

          <v-btn dark @click="step = 3">
            <span>Informações de sistema</span>
            <v-icon>settings</v-icon>
          </v-btn>

          <v-btn dark @click="step = 4">
            <span>Segurança</span>
            <v-icon>lock</v-icon>
          </v-btn>

          <v-btn dark @click="step = 5">
            <span>Funcionalidades</span>
            <v-icon>edit</v-icon>
          </v-btn>
      </v-bottom-nav>
    </v-card>
    <v-card-text>
      <v-stepper v-model="step" style="box-shadow: none;">
      <v-stepper-items pt-4 row wrap justify-space-around fill-height>
        <v-stepper-content step="1">
          <v-form ref="pessoais" v-model="valid" lazy-validation>
            <template>
              <v-flex xs12 class="text-xs-center mb-2"><h3>Dados pessoais</h3></v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Nome"
                  type="text"
                  v-model="usuario.nome"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Sobrenome"
                  v-model="usuario.sobrenome"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="CPF"
                  mask="###.###.###-##"
                  v-model="usuario.cpf"
                  :rules="[ rules.cpf]"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Número de telefone"
                  mask="(##) #####-####"
                  v-model="usuario.telefone"
                  :rules="[rules.telephone]"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Data de nascimento"
                  v-model="data_nascimento"
                  mask="##/##/####"
                  :error-messages="errorMessageBirthday"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Email do usuário"
                  v-model="usuario.email"
                  :rules="[rules.email]"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="verificacaoTelefone.cadastrado || (verificacaoTelefone.pessoa && usuario && verificacaoTelefone.pessoa.id_pessoa !=  usuario.id_pessoa)">
                  <v-card class="ma-2" elevation="4">
                    <v-card-title class="justify-center">
                      <h4
                        v-if="verificacaoTelefone.cadastrado || verificacaoTelefone.pessoa"
                        class="text-xs-center error--text"
                      >
                        Esse telefone já foi cadastrado
                      </h4>
                    </v-card-title>
                    <v-card-text>
                      <v-flex
                        class="error--text"
                        v-if="verificacaoTelefone.quantidade > 0"
                      >
                        {{ verificacaoTelefone.quantidade }} {{ verificacaoTelefone.quantidade === 1 ? 'pessoa cadastrou esse telefone' : 'pessoas cadastraram esse telefone' }}
                      </v-flex>
                      <v-flex
                        class="error--text"
                        v-if="verificacaoTelefone.ids_cadastrados.length > 0"
                      >
                        IDs que registraram esse telefone: <span v-for="(fone, index) in verificacaoTelefone.ids_cadastrados" :key="index">
                          {{ fone }}<span v-if="index < verificacaoTelefone.ids_cadastrados.length - 1 ">,</span>
                        </span>
                      </v-flex>
                      <v-layout wrap justify-space-between v-if="verificacaoTelefone.pessoa" class="error--text">
                        <v-flex xs12><h4 class="text-xs-center">Cadastro Firebase</h4></v-flex>
                        <v-flex xs11>Nome: {{ verificacaoTelefone.pessoa.nome_completo }}</v-flex>
                        <v-flex xs5>CPF: {{ verificacaoTelefone.pessoa.cpf }}</v-flex>
                        <v-flex xs5>ID: {{ verificacaoTelefone.pessoa.id_pessoa }}</v-flex>
                        <v-flex xs11>E-mail: {{ verificacaoTelefone.pessoa.email }}</v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
            </template>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-form ref="endereco" v-model="valid" lazy-validation>
              <template>
                <v-flex xs12 class="text-xs-center mb-2"><h3>Endereço</h3></v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Cep"
                    mask="#####-###"
                    v-model="endereco.cep"
                    @keyup="searchCep"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Logradouro"
                    v-model="endereco.logradouro"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Número"
                    v-model="endereco.numero"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Bairro"
                    v-model="endereco.bairro"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Cidade"
                    v-model="endereco.cidade"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Estado"
                    v-model="endereco.estado"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="País"
                    v-model="endereco.pais"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-flex>
              </template>
            </v-form>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-form ref="sistema" v-model="valid" lazy-validation>
              <template>
                <v-flex xs12 class="text-xs-center mb-2"><h3>Informações de sistema</h3></v-flex>
                <v-flex xs12>
                  <v-select
                    label="Verificação do CPF"
                    :items="verificacaoItems"
                    :item-text="'name'"
                    :item-value="'value'"
                    v-model="usuario.verificacao_cpf"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    label="Verificação de Documento"
                    :items="verificacaoItems"
                    :item-text="'name'"
                    :item-value="'value'"
                    v-model="usuario.verificacao_document"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    label="Verificação de Selfie"
                    :items="verificacaoItems"
                    :item-text="'name'"
                    :item-value="'value'"
                    v-model="usuario.verificacao_self"
                  >
                  </v-select>
                </v-flex>
                <v-layout row wrap>
                <v-flex xs6>
                  <div class="theme--light v-text-field v-text-field--is-booted">
                    <div class="v-input__slot">
                      <div class="v-text-field__slot">
                        <label class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Verificação de número celular</label>
                        <v-switch
                          color="primary"
                          v-model="usuario.verificacao_numero"
                        >
                        </v-switch>
                      </div>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="theme--light v-text-field v-text-field--is-booted">
                    <div class="v-input__slot">
                      <div class="v-text-field__slot">
                        <label class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Verificação de usuário</label>
                        <v-switch
                          inset
                          color="primary"
                          v-model="usuario.verificado"
                        >
                        </v-switch>
                      </div>
                    </div>
                  </div>
                </v-flex>
                </v-layout>
                <v-flex xs12>
                  <v-text-field
                    label="Limite de tentativas do usuário"
                    type="number"
                    v-model="usuario.quiz_number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Quantidade de tentativas realizadas"
                    type="number"
                    v-model="usuario.tentativas_quiz"
                  ></v-text-field>
                </v-flex>
                </template>
              </v-form>
          </v-stepper-content>
          <v-stepper-content step="4">
            <v-form ref="senhas" v-model="valid" lazy-validation>
              <template>
              <v-flex xs12 class="text-xs-center mb-2"><h3>Smartlock</h3></v-flex>
              <v-layout row wrap>
              <v-flex xs6>
                <div class="theme--light v-text-field v-text-field--is-booted">
                  <div class="v-input__slot">
                    <div class="v-text-field__slot">
                      <label class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Smartlock do Posto</label>
                      <v-switch
                        inset
                        color="primary"
                        v-model="usuario.smartlock_posto"
                      >
                      </v-switch>
                    </div>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6>
                <div class="theme--light v-text-field v-text-field--is-booted">
                  <div class="v-input__slot">
                    <div class="v-text-field__slot">
                      <label class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Smartlock da Empresa</label>
                      <v-switch
                        inset
                        color="primary"
                        v-model="usuario.smartlock_empresa"
                      >
                      </v-switch>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  readonly
                  label="Data de atualização do SmartLock"
                  type="date"
                  v-model="usuario.data_atualizacao_pin"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 offset-xs1>
                <v-text-field
                  label="Digite a nova senha do SmartLock"
                  type="password"
                  v-model="novo_pin"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 class="text-xs-center mb-2"><h3>Autenticação Em Duas Etapas</h3></v-flex>
              <v-flex xs6>
                <div class="theme--light v-text-field v-text-field--is-booted">
                  <div class="v-input__slot">
                    <div class="v-text-field__slot">
                      <label class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Autenticação por SMS</label>
                      <v-switch
                        inset
                        color="primary"
                        v-model="usuario.autenticacao"
                      >
                      </v-switch>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
            </template>
            </v-form>
          </v-stepper-content>
          <v-stepper-content step="5">
          <template>
            <v-flex xs12 class="text-xs-center mb-2"><h3>Funcionalidades</h3></v-flex>
            <v-layout row wrap>
            <v-flex xs6>
              <v-btn
                elevation="2"
                outlined
                @click="verifyEmail"
                round
                color="primary"
              >Verificar e-mail</v-btn>
            </v-flex>
            <v-flex xs6>
              <v-btn
                elevation="2"
                outlined
                @click="requestNewPassword"
                round
                color="primary"
              >Redefinir Senha</v-btn>
            </v-flex>
          </v-layout>
          </template>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card-text>
    <v-card-actions>
        <v-btn
          flat
          block
          color="primary"
          @click="
            fechar()
          "
          >Fechar</v-btn>
        <v-btn
          flat
          block
          color="primary"
          @click="
            salvar()
          "
          >Salvar</v-btn
        >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ['usuario'],
  data () {
    return {
      verificacaoTelefone: {
        cadastrado: false,
        quantidade: 0,
        ids_cadastrados: [],
        pessoa: undefined
      },
      projeto: undefined,
      errorMessageBirthday: '',
      valid: true,
      rules: {
        required: value => !!value || 'Obrigatório',
        telephone: value => (value.length === 0 || value.length === 11) || 'Número inválido. Formato válido: (##) #####-####',
        cpf: value => value.length === 11 || 'CPF inválido. Formato válido: ###.###.###-##',
        date: value => (value.length === 0 || value.length === 8) || 'Data inválida. Formato válido: ##/##/####',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'E-mail inválido'
        }
      },
      step: 1,
      verificacaoItems: [
        { name: 'Cancelado', value: 1 },
        { name: 'Limpo', value: 2 },
        { name: 'Confirmado', value: 3 },
        { name: 'Recusado', value: 4 }
      ],
      data_nascimento: undefined,
      novo_pin: undefined,
      endereco: {
        cep: undefined,
        logradouro: undefined,
        bairro: undefined,
        numero: undefined,
        cidade: undefined,
        estado: undefined,
        pais: undefined
      }
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    }
    // usuarioDataNascimento: {
    //   get: function () {
    //     try {
    //       return this.usuario.data_nascimento.split('-').reverse().join('/')
    //     } catch {
    //       return ' '
    //     }
    //   },
    //   set: function (newValue) {
    //     try {
    //       this.usuario.data_nascimento = newValue.split('/').reverse().join('-')
    //     } catch {
    //       return ' '
    //     }
    //   }
    // }
  },
  methods: {
    fechar () {
      this.step = 1
      this.$refs.pessoais.reset()
      this.$refs.endereco.reset()
      this.$refs.sistema.reset()
      this.$refs.senhas.reset()
      this.$emit('fechar')
    },
    salvar () {
      switch (this.step) {
        case 1:
          if (this.$refs.pessoais.validate()) {
            this.step = 1
            this.editarDadosPessoais()
            setTimeout(() => this.fechar(), 2000)
          }
          break
        case 2:
          if (this.$refs.endereco.validate()) {
            this.step = 1
            this.editarEndereco()
            setTimeout(() => this.fechar(), 2000)
          }
          break
        case 3:
          if (this.$refs.sistema.validate()) {
            this.step = 1
            this.editarInfoSistema()
            setTimeout(() => this.fechar(), 2000)
          }
          break
        case 4:
          if (this.$refs.senhas.validate()) {
            this.step = 1
            this.editarSenhas()
            setTimeout(() => this.fechar(), 2000)
          }
          break
        default:
          alert('Inválido')
      }
    },
    searchCep () {
      if ((this.endereco.cep).length >= 8) {
        fetch(`https://viacep.com.br/ws/${this.endereco.cep}/json/`, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Accept: 'application/json'
        }
      })
        .then((res) => res.json())
        .then((json) => {
          this.endereco.logradouro = json.logradouro
          this.endereco.bairro = json.bairro
          this.endereco.cidade = json.localidade
          this.endereco.estado = json.uf
          this.endereco.pais = 'Brasil'
        })
      }
    },
    verifyEmail () {
      this.$store
        .dispatch('updatePessoa', {
          id_pessoa: this.usuario.id_pessoa,
          email_verified: true })
    },
    verificarTelefone () {
      this.$store.dispatch('verificarTelefone', {
        id_pessoa: this.usuario.id_pessoa,
        telefone: this.usuario.telefone.slice(3, 11)
      }).then(json => {
        this.verificacaoTelefone = json
      })
    },
    requestNewPassword () {
      this.$store
      .dispatch('updatePessoa', {
        id_pessoa: this.usuario.id_pessoa,
        redefinir_senha: true
      })
    },
    editarDadosPessoais () {
      if (this.data_nascimento) {
        this.data_nascimento = `${this.data_nascimento.slice(4, 8)}-${this.data_nascimento.slice(2, 4)}-${this.data_nascimento.slice(0, 2)}`
      }
      this.$store
      .dispatch('updatePessoa', {
        id_pessoa: this.usuario.id_pessoa,
        nome: this.usuario.nome,
        sobrenome: this.usuario.sobrenome,
        cpf: this.usuario.cpf,
        telefone: this.usuario.telefone ? this.usuario.telefone : null,
        deletar_telefone: !this.usuario.telefone,
        data_nascimento: this.data_nascimento ? this.data_nascimento : null,
        email: this.usuario.email,
        projeto: this.projeto ? this.projeto || this.projeto !== 'apetrus' : null
      }).then(() => {
        this.$emit('success', 'Dados pessoais atualizados com sucesso.')
      }).catch(() => {
        this.$emit('error', 'Não foi possível atualizar os Dados pessoais do usuário.')
      })
    },
    editarEndereco () {
      this.$store
      .dispatch('updatePessoa', {
        id_pessoa: this.usuario.id_pessoa,
        endereco: this.endereco
      }).then(() => {
        this.$emit('success', 'Endereço atualizado com sucesso.')
      }).catch(() => {
        this.$emit('error', 'Não foi possível atualizar o endereço do usuário.')
      })
    },
    editarInfoSistema () {
      this.$store
      .dispatch('updatePessoa', {
        id_pessoa: this.usuario.id_pessoa,
        verificacao_cpf: this.usuario.verificacao_cpf,
        verificacao_document: this.usuario.verificacao_document,
        verificacao_self: this.usuario.verificacao_self,
        verificacao_numero: this.usuario.verificacao_numero,
        verificado: this.usuario.verificado,
        quiz_number: this.usuario.quiz_number,
        tentativas_quiz: this.usuario.tentativas_quiz
      }).then(() => {
        this.$emit('success', 'As informações de sistema foram atualizadas com sucesso.')
      }).catch(() => {
        this.$emit('error', 'Não foi possível atualizar as informações de sistema do usuário.')
      })
    },
    editarSenhas () {
      this.$store
      .dispatch('updatePessoa', {
        id_pessoa: this.usuario.id_pessoa,
        smartlock_posto: this.usuario.smartlock_posto,
        smartlock_empresa: this.usuario.smartlock_empresa,
        autenticacao: this.usuario.autenticacao,
        pin: this.novo_pin ? this.novo_pin : null
      }).then(() => {
        this.$emit('success', 'As configurações de senha foram atualizadas com sucesso.')
      }).catch(() => {
        this.$emit('error', 'Não foi possível atualizar as configurações de senha do usuário.')
      })
    },
    verificarVariavel (message) {
      try {
        return message
      } catch {
        return ' '
      }
    }
  },
  watch: {
    // usuarioDataNascimento (val) {
    //   if (val.length === 8) {
    //     this.errorMessageBirthday = ''
    //   } else {
    //     this.errorMessageBirthday = 'Data inválida. Formato válido: ##/##/####'
    //   }
    // },
    usuario (val) {
      if (val) {
        try {
          if (val.endereco) {
            this.endereco = this.usuario.endereco
          }
          if (val.data_nascimento) {
            this.data_nascimento = val.data_nascimento.split('-').reverse().join('/')
          }
        } catch {
          // pass
        }
      } else {
        this.fechar()
      }
    },
    'usuario.telefone' (val) {
     if (val && val.length === 11) {
      this.verificarTelefone()
     } else {
      this.verificacaoTelefone.pessoa = undefined
      this.verificacaoTelefone.ids_cadastrados = []
      this.verificacaoTelefone.cadastrado = false
      this.verificacaoTelefone.quantidade = 0
     }
    }
  },
  mounted () {
    if (this.usuario) {
      if (this.usuario.endereco) {
        this.endereco = this.usuario.endereco
      }
      if (this.usuario.data_nascimento) {
        this.data_nascimento = this.usuario.data_nascimento.split('-').reverse().join('/')
      }
    }
  }
}
</script>
<style>
.v-navigation-drawer {
  transition: none !important
}

.lightbox {
  box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.4) 0%,
    transparent 72px
  )
}
</style>
